@import "../../../../css/_mixins.scss";

.customContent {
  padding: 28px 40px;
  background-color: var(--red);

  @include small-desktop {
    padding: 24px 32px;
  }
  @include tablet {
    padding: 20px 20px;
  }
  @include mobile {
    padding: 16px 14px;
  }
}

.minimizedContent {
  position: relative;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  padding: 14px 20px;
  background-color: var(--red);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;

  @include tablet {
    padding: 12px 16px;
    gap: 10px;
  }
  @include mobile {
    padding: 10px 12px;
    gap: 8px;
  }

  .barTitle {
    flex: 0 0 auto;
    font-weight: 700;
    color: #fff;
    font-size: 18px;
    letter-spacing: -0.2px;

    @include mobile {
      font-size: 16px;
    }
  }

  .inputRedeemCode {
    flex: 1 1 200px;
    width: auto;
    max-width: 320px;
    height: 44px;
    text-align: center;
    font-size: 17px;
    font-weight: 600;
    color: var(--gray);
    background-color: #fff;
    border: none;
    border-radius: 22px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 0 16px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-sizing: border-box;

    &::placeholder {
      color: #b5b5b5;
      font-weight: 500;
      letter-spacing: 0;
      text-transform: none;
    }

    &:focus {
      outline: 2px solid var(--yellow);
      outline-offset: 1px;
    }

    @include mobile {
      height: 40px;
      font-size: 15px;
      flex: 1 1 160px;
    }
  }

  .btnRedeemMinimized {
    flex: 0 0 auto;
    height: 44px;
    padding: 0 18px;
    background-color: transparent;
    border: 2px solid rgba(255, 255, 255, 0.85);
    border-radius: 22px;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease;

    &:hover {
      background-color: #fff;
      color: var(--red);
    }
    &:active {
      transform: translateY(1px);
    }

    @include mobile {
      height: 40px;
      padding: 0 14px;
      font-size: 13px;
    }
  }
}
